<template>
  <v-container fluid style="padding: 0; margin: 0;">
    <v-row no-gutters>
      <v-col style="background-color: #b3a258; padding-top: 10px; padding-bottom: 10px; text-align: right;" cols="12" sm="12" md="12" lg="12">
        <span v-for="(item, i) in items" :key="i" style="margin-right: 20px; font-weight: bold;" v-show="isSwitchLanguage">
          <router-link
            :to="item.value"
            style="color: #ffffff; text-decoration: none;"
          >{{ item.text }}</router-link>
        </span>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col align="center" cols="12" sm="12" md="12" lg="12" style="padding: 10px 0;">
        <v-btn
          color="#b3a258"
          dark
          small
          fixed
          top
          left
          fab
          :to="lang"
          v-show="show"
          style="z-index: 99;"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <v-img
          src="https://privileges.anantaravacationclub.com/assets/images/Anantara-Vacation-Club-CW.png"
          style="width: 120px; height: auto; "
          lazy-src="../assets/images/before-show.jpg"
        />

        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
          </v-row>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Logo",
  props: {
    show: Boolean,
    isSwitchLanguage: Boolean
  },
  data() {
    return {
      name: this.$route.params.name,
      lang: "/home/" + this.$route.params.lang,
      items: []
    };
  },
  methods: {
    loadConfig() {
      this.items = [
        {
          text: "English",
          value: {
            name: this.name == null ? "home" : "destination",
            params: { lang: "en" }
          }
        },
        {
          text: "中文",
          value: {
            name: this.name == null ? "home" : "destination",
            params: { lang: "cn" }
          }
        },
        {
          text: "ไทย",
          value: {
            name: this.name == null ? "home" : "destination",
            params: { lang: "th" }
          }
        }
      ];
    }
  },
  mounted() {
    this.loadConfig();
  }
};
</script>

<style scoped>
</style>